import { buildCrudRoutes } from '@/app/arch/components/crud/CrudRouter';
import { buildSubModuleRoute } from '@/app/arch/helpers/RouterHelper';
import moduleBreadcrumbs from 'Modules/contacard/moduleBreadcrumbs';

const history = buildCrudRoutes({
  baseName: 'shortlistHistory',
  basePath: 'history',
  baseBreadcrumbs: [
    ...moduleBreadcrumbs,
  ],
  card: {
    title: 'Histórico de consulta',
    icon: 'format-list-bulleted-type',
  },
  moduleActive: 'contacard',
  subModuleActive: 'shortlist',
  listRoute: {
    pageContent: () => import('Modules/contacard/shortlist/ShortList.vue'),
    searchComponent: () => import('Arch/components/crud/components/OnlySearchFilter.vue'),
    speedFilter: () => import('Modules/contacard/shortlist/components/ShortlistSpreedFilter.vue'),
    searchOptions: { label: 'Buscar documento', searchAttribute: 'search' },
    navigateBackRoute: 'contacard.submodules.list',
    pageTitle: 'Histórico de pesquisa ',
  },
});

const SearchCsnu = buildCrudRoutes({
  baseName: 'searchCsnu',
  basePath: 'search-csnu',
  baseBreadcrumbs: [
    ...moduleBreadcrumbs,
  ],
  card: {
    title: 'Consulta na lista CSNU',
    icon: 'magnify',
  },
  moduleActive: 'contacard',
  subModuleActive: 'shortlist',
  listRoute: {
    pageContent: () => import('Modules/contacard/shortlist/ShortSearchList.vue'),
    navigateBackRoute: 'contacard.submodules.list',
    pageTitle: 'Consultar na lista CSNU',
  },
});

const SearchOfac = buildCrudRoutes({
  baseName: 'searchofac',
  basePath: 'search-ofac',
  baseBreadcrumbs: [
    ...moduleBreadcrumbs,
  ],
  card: {
    title: 'Consulta na lista OFAC',
    icon: 'magnify',
  },
  moduleActive: 'contacard',
  subModuleActive: 'shortlist',
  listRoute: {
    pageContent: () => import('Modules/contacard/shortlist/ShortSearchList.vue'),
    navigateBackRoute: 'contacard.submodules.list',
    pageTitle: 'Consultar na lista OFAC',
  },
});

export default [
  buildSubModuleRoute({
    name: 'shortlist',
    path: 'shortlist/',
    moduleId: 'contacard',
    subModuleTitle: 'Listas restritivas',
    children: [
      ...history,
      ...SearchCsnu,
      ...SearchOfac,
    ],
  }),
];
